import { InsuranceContract } from "../../../../types";
import { isLifeInsuranceContract } from "../../../../utils";
import { LifeInsurancesData } from "./life/LifeInsurancesData";
import { NonLifeInsurancesData } from "./NonLifeInsurancesData";

interface Props {
  contract: InsuranceContract;
}

export const ContractInsurancesData = ({ contract }: Props) =>
  isLifeInsuranceContract(contract) ? (
    <LifeInsurancesData contract={contract} />
  ) : (
    <NonLifeInsurancesData contract={contract} />
  );
